<template>
    <div class="header">
        <div class="header-wrap wrap">
            <!-- logo -->
            <div class="hj-logo"><a href="/#/index"><img :src="logo" alt="荟镜XR 慧建智联"></a></div>
            <!-- menu -->
            <div class="hj-menus">
                <dl v-for="(item, index) in items" :key="index" :class="index === localActive ? 'on' : ''">
                    <dt @mouseenter="setActives(index,0)">
                        <a v-if="item.path" :href="item.path">{{ item.title }}</a>
                        <a v-else>{{ item.title }}</a>
                    </dt>
                    <dd v-if="index === actives">
                        <a v-for="(subItem, subIndex) in item.subItems" :key="subIndex" :href="subItem.href">
                            {{subItem.title }}
                        </a>
                    </dd>
                </dl>
            </div>
            <!-- contact -->
            <div class="hj-contact">
                <a>联系 13269322718</a>
                <button @click="showContact()">合作咨询</button>
            </div>
        </div>
        <div class="m-toper">
            <div class="wrap clearfix">
                <div class="hh-logo"><a href="/#/index"><img :src="logo" alt="荟镜XR 慧建智联"></a></div>
                <h2 class="title">{{ title }}</h2>
                <div class="burger" id="burger" @click="openMenu()"><img src="../../src/assets/image/icon/menu.png" alt="荟镜XR 慧建智联"></div>
            </div>
        </div>
        <div class="m-header" :class="{ over: isShow }">
            <div class="m-header-layer"></div>
            <div class="m-header-box">
                <div class="hh-menus">
                    <div class="top">
                        <img src="../../src/assets/image/icon/icon_menu_grey.png" alt="荟镜XR 慧建智联">
                        <img src="../../src/assets/image/icon/icon_close.png" @click="close()" alt="荟镜XR 慧建智联">
                    </div>
                    <dl v-for="(item, index) in itemsM" :key="index" :class="index === localActive ? 'on' : ''">
                        <dt @click="setActives(index, 1, item.path)">
                            <h2>{{ item.title }}</h2>
                            <img v-if="item.subItems.length > 0 && index == actives"
                                src="../assets/image/icon/icon_up.png" alt="荟镜XR 慧建智联">
                            <img v-if="item.subItems.length > 0 && index != actives"
                                src="../assets/image/icon/icon_down.png" alt="荟镜XR 慧建智联">
                        </dt>
                        <!-- :href="subItem.href" -->
                        <dd v-if="index === actives">
                            <a v-for="(subItem, subIndex) in item.subItems" :key="subIndex" :href="subItem.href"
                                :class="{ active: subIndex === num }" @click="handleSubItemClick(subIndex, item.title)">
                                {{ subItem.title }}
                            </a>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { baseUrl } from '../api/images';
export default {
    props: {
        active: {
            type: Number, 
            required: false, 
            default: 0
        },
        title: {
            type: String,
            required: false, 
            default: ''
        }
    },
    data() {
        return {
            logo: baseUrl + 'logo.png',
            isContactVisible: false,
            localActive: this.active,
            items: [
                {
                    title: '首页',
                    subItems: [],
                    path:'/#/index'
                },
                {
                    title: '产品',
                    subItems: [
                        { title: 'XR1', href: '/#/products/XR1' },
                        { title: 'XR2', href: '/#/products/XR2' },
                        { title: 'VR1', href: '/#/products/VR1' },
                        { title: 'VR2', href: '/#/products/VR2' }
                    ],
                    path: ''
                },
                {
                    title: '解决方案',
                    subItems: [
                        { title: '飞行', href: '/#/solutions/aviation' },
                        { title: '军体', href: '/#/solutions/training' },
                        { title: '工业', href: '/#/solutions/industry' },
                        { title: '低空', href: '/#/solutions/lowAltitude' }
                    ],
                    path: ''
                },
                {
                    title: '新闻资讯',
                    subItems: [],
                    path: '/#/news'
                },
                {
                    title: '技术支持',
                    subItems: [],
                    path: '/#/support'
                },
                {
                    title: '关于我们',
                    subItems: [],
                    path: '/#/about'
                }
            ],
            itemsM: [
                {
                    title: '首页',
                    subItems: [],
                    path:'/#/index'
                },
                {
                    title: '产品',
                    subItems: [
                        { title: 'XR1', href: '/#/products/XR1' },
                        { title: 'VR1', href: '/#/products/VR1' },
                        { title: 'XR2', href: '/#/products/XR2' },
                        { title: 'VR2', href: '/#/products/VR2' },
                        // { title: 'AR1', href: '/#/products/AR1' }
                    ],
                    path: ''
                },
                {
                    title: '解决方案',
                    subItems: [
                        { title: '飞行', href: '/#/solutions/aviation' },
                        { title: '军体', href: '/#/solutions/training' },
                        { title: '工业', href: '/#/solutions/industry' },
                        { title: '低空', href: '/#/solutions/lowAltitude' }
                    ],
                    path: ''
                },
                {
                    title: '新闻资讯',
                    subItems: [],
                    path: '/#/news'
                },
                {
                    title: '关于我们',
                    subItems: [],
                    path: '/#/about'
                }
            ],
            actives:0,
            num:10,
            isShow:false
        }; 
    },
    
    
    methods:{
        showContact() {
            this.$emit('show-contact')
        },
        setActives(index,num,path) {
            if (path) window.location.href = path;
            else this.actives = this.actives == index && num == 1  ? 10 : index;
        },
        handleSubItemClick(subIndex) {
            this.num = subIndex;
        },
        openMenu(){
            this.isShow = true;
        },
        close(){
            this.isShow = false;
        }
    } 
}
</script>
<style scoped>
    @import '../assets/css/header.css';
</style>